import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { useAuth, useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { BASE, URLS, APIS, SF_MSG_INFO } from "@/tra/tancis/ptli/elctdoc/rcpn/services/PtliDocRcpnMgmtService";

/*
 * Document Message Popup
 * !== 전자문서 메시지 팝업 ==!
 */
export const PTLI0701003Q = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0047", "auth_ptli0004", "auth_ptli0049", "auth_ptli0015", "auth_ptlianyADM", "auth_ptli0048"],
    });
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const { callback, msg } = props;

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        msgForm: useForm({
            defaultSchema: SF_MSG_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        // Message original content formatted as json structure !== 메시지 원본 내용 json 구조로 포맷 ==!
        if (!comnUtils.isEmpty(msg)) {
            try {
                const jsonMsg = JSON.parse(msg);
                const sMsg = JSON.stringify(jsonMsg, null, 2);

                form.msgForm.setValue("msg", sMsg);
            } catch (error) {
                form.msgForm.setValue("msg", msg);
            }
        }
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.msgForm.schema.msg} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
